import http from "../utils/http";

function mapRequest(raw) {
  const data = raw.attributes || raw;
  return {
    id: raw.documentId || data.documentId || raw.id,
    taskType: data.task_type,
    title: data.title,
    quantity: data.quantity,
    status: data.status,
    createdAt: data.createdAt,
    completedAt: data.completed_at,
  };
}

export async function fetchPreparationRequests(status, page = 0, pageSize = 25) {
  const response = await http.get("/preparation-requests", {
    params: {
      "filters[status][$eq]": status,
      "sort[0]": status === "completed" ? "completed_at:desc" : "createdAt:desc",
      "pagination[page]": page + 1,
      "pagination[pageSize]": pageSize,
    },
  });

  return {
    rows: (response.data?.data || []).map(mapRequest),
    total: response.data?.meta?.pagination?.total || 0,
  };
}

export async function createPreparationRequest({ taskType, title, quantity }) {
  const response = await http.post("/preparation-requests", {
    data: {
      task_type: taskType,
      title: title.trim(),
      quantity: Number(quantity),
    },
  });
  return mapRequest(response.data.data);
}

export async function completePreparationRequest(id) {
  const response = await http.put(`/preparation-requests/${id}`, {
    data: { status: "completed" },
  });
  return mapRequest(response.data.data);
}
